import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { SharedModule } from '@shared/shared.module';
import { TemplateIconPipe } from '@shared/pipes/template-icon.pipe';
import { TemplateCreatedComponent } from './template-created/template-created.component';

// import { TemplatesSliderComponent } from './templates-slider/templates-slider.component';
// import { TemplatesListComponent } from './templates-list/templates-list.page';
// import { EditTemplatePage } from './edit-template/edit-template.component';
// import { PlanTemplatePage } from './pages/plan-template/plan-template.component';
// import { ReorderTemplatesPage } from './pages/reorder-templates/reorder-templates.component';


@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SharedModule
  ],
  declarations: [
    // TemplatesSliderComponent,
    // TemplatesListComponent,
    // EditTemplatePage,
    // PlanTemplatePage,
    // ReorderTemplatesPage,
    TemplateCreatedComponent
  ],
  exports: [
    // TemplatesSliderComponent,
    // TemplatesListComponent,
    // EditTemplatePage,
    // PlanTemplatePage,
    // ReorderTemplatesPage,
    TemplateCreatedComponent,
  ]
})
export class TemplatesModule {
}
